var map = {
	"./AppMain.vue": 5385,
	"./Avatar.vue": 7788,
	"./Breadcrumb.vue": 8663,
	"./Logo.vue": 7319,
	"./NavBar.vue": 7288,
	"./SideBar/components/MenuItem.vue": 5411,
	"./SideBar/components/SideBarItem.vue": 3828,
	"./SideBar/components/Submenu.vue": 4283,
	"./SideBar/index.vue": 4847,
	"./TabsBar.vue": 9444
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4295;